const questionnaireItemsPath = '/questionnaire-items';
export default questionnaireItemsPath;
